import { render, staticRenderFns } from "./SetAddress.vue?vue&type=template&id=1afa52a0&scoped=true"
import script from "./SetAddress.vue?vue&type=script&lang=js"
export * from "./SetAddress.vue?vue&type=script&lang=js"
import style0 from "./SetAddress.vue?vue&type=style&index=0&id=1afa52a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa52a0",
  null
  
)

export default component.exports